import { createContext, useContext } from "react";
export const ThemeContext = createContext({});
export const useTheme = () => {
    const theme = useContext(ThemeContext);
    if (!theme)
        throw new Error("useTheme must be use inside Theme");
    return theme;
};
//# sourceMappingURL=themeContext.js.map